<template>
	<div>
		<v-container>
			<v-row>
				<v-col cols="12">
					<v-breadcrumbs :items="breadcrumbs">
						<template #divider>
							<v-icon>mdi-chevron-left</v-icon>
						</template>
					</v-breadcrumbs>
				</v-col>
			</v-row>
			<v-row>
				<v-col cols="12" class="pa-2">
					<v-data-table
						hide-default-footer
						:headers="headers"
						:items="specialities"
						class="elevation-1"
						:loading="loading"
						:items-per-page="-1"
					>
						<template #top>
							<v-toolbar flat>
								<v-toolbar-title class="px-4">الفئات المستهدفة</v-toolbar-title>
								<v-divider insert vertical></v-divider>
								<v-spacer></v-spacer>
								<v-btn class="primary" :disabled="!privs.new" @click="showAddNewSpecialty = true">فئة مستهدفة جديدة</v-btn>
							</v-toolbar>
						</template>

						<template #[`item.delete`]="{ item }">
							<v-tooltip bottom>
								<template #activator="{ on }">
									<v-btn
										icon
										medium
										:disabled="loading"
										v-on="on"
										@click="deleteSpeciality(item.id)"
									>
										<v-icon color="error">mdi-account-multiple-remove</v-icon>
									</v-btn>
								</template>
								<span>حذف</span>
							</v-tooltip>
						</template>

						<template #[`item.actions`]="{ item }">
							<v-tooltip bottom>
								<template #activator="{ on }">
									<v-btn
										icon
										medium
										:disabled="!privs.manage || loading"
										v-on="on"
										@click="editSpecialty(item)"
									>
										<v-icon color="primary">mdi-pen</v-icon>
									</v-btn>
								</template>
								<span>تحرير</span>
							</v-tooltip>

							<v-tooltip v-if="item.userID" bottom>
								<template #activator="{ on }">
									<v-btn
										icon
										medium
										:disabled="!privs.manage || loading"
										v-on="on"
										@click="approveSpeciality(item)"
									>
										<v-icon color="primary">mdi-check-decagram</v-icon>
									</v-btn>
								</template>
								<span>تفعيل</span>
							</v-tooltip>

							<v-tooltip v-else bottom>
								<template #activator="{ on }">
									<v-btn
										icon
										medium
										:disabled="!privs.manage || loading"
										v-on="on"
										@click="disableSpeciality(item)"
									>
										<v-icon color="error">mdi-decagram-outline</v-icon>
									</v-btn>
								</template>
								<span>إلغاء التفعيل</span>
							</v-tooltip>
						</template>

						<template #[`item.approve`]="{ item }">
							<v-chip v-if="!item.userID" class="green" dark small>
								<v-icon left>mdi-check-decagram</v-icon>
								مفعلة
							</v-chip>
						</template>
					</v-data-table>
				</v-col>
			</v-row>
		</v-container>

		<v-dialog v-model="showAddNewSpecialty" width="500">
			<v-card>
				<v-card-title primary-title>
					<v-spacer></v-spacer>
					<div>إضافة فئة جديدة</div>
					<v-spacer></v-spacer>
				</v-card-title>
				<v-card-text>
					<v-form v-model="valid">
						<v-row dense>
							<v-col cols="12" class="py-0">
								<v-text-field
									v-model="newSpecialty.name"
									outlined
									label="اسم الفئة"
									:rules="[rules.required]"
								></v-text-field>
							</v-col>

							<v-col cols="12" class="py-0">
								<v-text-field
									v-model="newSpecialty.femName"
									outlined
									label="اسم الفئة المؤنثة"
								></v-text-field>
							</v-col>

							<v-col cols="12" class="py-0">
								<v-text-field v-model="newSpecialty.description" outlined label="وصف الفئة"></v-text-field>
							</v-col>

							<v-col cols="12" class="text-center">
								<v-btn color="primary" :disabled="!valid" :loading="loading" @click="addNewSpecialty">إضافة</v-btn>
							</v-col>
						</v-row>
					</v-form>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="editDialog" width="500">
			<v-card>
				<v-card-title primary-title>
					<v-spacer></v-spacer>
					<div>تحرير على فئة</div>
					<v-spacer></v-spacer>
				</v-card-title>
				<v-card-text>
					<v-form v-model="valid2">
						<v-row dense>
							<v-col cols="12" class="py-0">
								<v-text-field
									v-model="edittingSpecialty.name"
									outlined
									label="اسم الفئة"
									:rules="[rules.required]"
								></v-text-field>
							</v-col>

							<v-col cols="12" class="py-0">
								<v-text-field
									v-model="edittingSpecialty.femName"
									outlined
									label="اسم الفئة المؤنثة"
								></v-text-field>
							</v-col>

							<v-col cols="12" class="py-0">
								<v-text-field v-model="edittingSpecialty.description" outlined label="وصف الفئة"></v-text-field>
							</v-col>

							<v-col cols="12" class="text-center">
								<v-btn color="primary" :disabled="!valid2" :loading="loading" @click="updateSpecialty">حفظ</v-btn>
							</v-col>
						</v-row>
					</v-form>
				</v-card-text>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import rulesMixin from "@/mixins/rules-mixin";
import client from "@/client";
import clientNotifier from "@/clientNotifier";

export default {
	mixins: [rulesMixin, require("@/mixins/router-mixin").default],
	data() {
		return {
			privs: {},
			breadcrumbs: [
				{ text: 'لوحة التحكم', to: { name: "dashboard-home" } },
				{ text: 'الفئات المستهدفة', disabled: true }
			],
			specialities: [],
			loading: true,
			headers: [
				{ value: "id", text: "المعرف" },
				{ value: "name", text: "اسم الفئة" },
				{ value: "femName", text: "اسم الفئة المؤنثة" },
				// { value: "description", text: "وصف الفئة" },
				// { value: "userID", text: "المستخدم" },
				{ value: "approve", text: "مفعلة" },
				{ value: "actions", text: "العمليات" },
			],
			valid: false,
			valid2: false,
			showAddNewSpecialty: false,
			newSpecialty: {
				name: null,
				femName: null,
				description: null
			},
			edittingSpecialty: {},
			editDialog: false
		};
	},
	mounted() {
		this.getSpecialities();
		this.getPrivileges();
	},
	methods: {
		getPrivileges() {
			client
				.get("/api/privilege/specialitesIcons")
				.then(response => {
					console.log(response);
					this.privs = response.data.data;
				})
				.catch(err => {
					console.log(err);
				});
		},
		getSpecialities() {
			this.specialities = [];
			client
				.get("/api/specialties/all")
				.then(response => {
					this.loading = false;
					this.specialities = response.data;
					console.log(response);
				})
				.catch(err => {
					console.log(err);
				});
		},
		approveSpeciality(item) {
			this.loading = true;

			clientNotifier
				.post("/api/specialties/approve/" + item.id, {})
				.then(response => {
					console.log(response);
					item.userID = null;
				})
				.catch(err => {
					console.log(err);
				})
				.finally(() => {
					this.loading = false;
				});
		},
		disableSpeciality(item) {
			this.loading = true;

			clientNotifier
				.post("/api/specialties/deactivate/" + item.id)
				.then(response => {
					console.log(response);
					item.userID = 1;
				})
				.catch(err => {
					console.log(err);
				})
				.finally(() => {
					this.loading = false;
				});
		},
		deleteSpeciality(id) {
			this.loading = true;

			client
				.delete("/api/replacements/deleteSpecialtiesFromList/" + id)
				.then(response => {
					if (response == undefined) throw new Error("delete does not use then/catch");

					var index = this.specialities.findIndex(spec => {
						return spec.id == id;
					});

					if (index != -1) {
						this.specialities.splice(index, 1);
					}

				})
				.catch(err => {
					console.log(err);
				})
				.finally(() => {
					this.loading = false;
				});
		},
		addNewSpecialty() {
			this.loading = true;
			var data = {
				...this.newSpecialty
			};
			clientNotifier
				.post("/api/courses/newSpecialties", data)
				.then(response => {
					var newSpec = {
						id: response.data.data.id,
						name: this.newSpecialty.name,
						femName: this.newSpecialty.femName,
						userID: "fake-id"
					};
					this.specialities.push(newSpec);
					this.showAddNewSpecialty = false;
					this.newSpecialty = {
						name: null,
						femName: null,
						description: null
					};
					console.log(response);
				})
				.catch(err => {
					console.log(err);
				})
				.finally(() => {
					this.loading = false;
				});
		},
		editSpecialty(spec) {
			this.edittingSpecialty = { 
				specialtiesID: spec.id,
				...spec
			};
			this.editDialog = true;
		},
		updateSpecialty() {
			this.loading = true;
			clientNotifier
				.post("/api/specialties/update", this.edittingSpecialty)
				.then(response => {
					console.log(response)
					this.editDialog = false;
					this.getSpecialities();
				})
				.catch(err => {
					console.log(err);
					this.loading = false;
				})
		}
	}
};
</script>